<ng-container>
  <app-event-management-section-heading
    [title]="'provide_registration_details' | t"
    [description]="'provide_registration_details_description' | t"
  ></app-event-management-section-heading>

  <app-input-row
    [label]="'event_form_enabled_registration' | t"
    [labelDescription]="'event_form_enabled_registration_description' | t"
  >
    <app-radio
      [fc]="innerForm.controls.event_registration_open"
      [label]="'no' | t"
      [value]="true"
    ></app-radio>
    <app-radio
      [fc]="innerForm.controls.event_registration_open"
      [label]="'yes' | t"
      [value]="false"
    ></app-radio>
  </app-input-row>

  <app-input-row
    [label]="'event_form_registration_start_datetime' | t"
    [labelDescription]="
      'event_form_registration_start_datetime_description' | t
    "
  >
    <div class="row">
      <div class="col-4">
        <app-date-input
          [fc]="innerForm.controls.event_registration_start_date"
        ></app-date-input>
      </div>
      <div class="col-3">
        <app-time-input
          [fc]="innerForm.controls.event_registration_start_time"
        ></app-time-input>
      </div>
    </div>
  </app-input-row>

  <app-input-row
    [label]="'event_form_registration_finish_datetime' | t"
    [labelDescription]="
      'event_form_registration_finish_datetime_description' | t
    "
  >
    <div class="row">
      <div class="col-4">
        <app-date-input
          [minDate]="minEventRegistrationFinishDate"
          [fc]="innerForm.controls.event_registration_end_date"
        ></app-date-input>
      </div>
      <div class="col-3">
        <app-time-input
          [fc]="innerForm.controls.event_registration_end_time"
        ></app-time-input>
      </div>
    </div>
  </app-input-row>
</ng-container>
